import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CantinaService {

  idxTvSelezionato = null;
  idxViSelezionato = null;
  idxPacchettoSelezionato = null;

  infoSpedizioniSconti = null;

  constructor(private http: HttpClient) { }

  getStato(cantina): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/cantina/' + cantina + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getTipoVisite(cantina, lingua): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/tipivisite/' + cantina + '/' + lingua + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getTipoVisiteBySezione(cantina, lingua, sezione): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/tipivisite_sezione/' + cantina + '/' + lingua + '/' + sezione + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getRecensioni(cantina): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/recensioni/' + cantina + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getFaqs(cantina, lingua): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/faqs/' + cantina + '/' + lingua + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getTipoVisiteCollegate(cantina, lingua, idSezione): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/tipivisitecollegate/' + cantina + '/' + lingua + '/' + idSezione + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getVini(cantina, lingua): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/vini/' + cantina + '/' + lingua + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getVinoById(id, codiceForm, lingua): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/vino-by-id/' + id + '/' + codiceForm + '/' + lingua + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getPacchetti(cantina, lingua): Observable<any> {
    return this.http.get<any[]>(
      environment.apiUrl + 'public/iframe/pacchetti/' + cantina + '/' + lingua + '/'
    )
      .pipe(map(response => {
        return response;
      }));
  }

  getIdxTvSelezionato() {
    return this.idxTvSelezionato;
  }

  setIdxTvSelezionato(valore) {
    this.idxTvSelezionato = valore;
  }

  getIdxViSelezionato() {
    return this.idxViSelezionato;
  }

  setIdxViSelezionato(valore) {
    this.idxViSelezionato = valore;
  }

  getInfoSpedizioniSconti() {
    return this.infoSpedizioniSconti
  }

  setInfoSpedizioniSconti(valore) {
    this.infoSpedizioniSconti = valore;
  }

  getIdxPaSelezionato() {
    return this.idxPacchettoSelezionato;
  }

  setIdxPaSelezionato(valore) {
    this.idxPacchettoSelezionato = valore;
  }

}
